import EFPicture from '@elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

let sceneTextEnterK: any = null,
    sceneTextLeaveK: any = null;
export default function K() {
    const { useLang, useRouter, useEffect, useState, useRef, gtm, Link } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('delta_pro_ultra.launch.detail');
    const [textEnter, setTextEnter] = useState(false);
    const LOCAL_SITES: string = ['jp'];

    const cards: any[] = [
        {
            title: 'secK_card1_title',
            desc: 'secK_card1_desc',
            img: `/responsive/picture/delta-pro-ultra/launch/11_1${LOCAL_SITES.includes(locale) ? `_${locale}` : ''}`,
        },
        {
            title: 'secK_card2_title',
            desc: 'secK_card2_desc',
            img: `/responsive/picture/delta-pro-ultra/launch/11_2${LOCAL_SITES.includes(locale) ? `_${locale}` : ''}`,
            url: ['us', 'ca', 'mx'].includes(locale) ? '/smart-home-panel-2' : undefined,
        },
    ];

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const resizeAni = () => {
                if (sceneTextEnterK) {
                    AniContainer.removeScene(sceneTextEnterK);
                    sceneTextEnterK = null;
                }
                if (sceneTextLeaveK) {
                    AniContainer.removeScene(sceneTextLeaveK);
                    sceneTextLeaveK = null;
                }

                const clientH = (window.innerHeight || 0) * 0.2;
                const startH = Math.min(clientH, 150);
                sceneTextEnterK = AniContainer.create({
                    triggerElement: '.dpu-detail-K .text-info',
                    triggerHook: 1,
                    offset: startH, //isOnlyH5 ? textTarget?.offsetHeight / 2 : textTarget?.offsetHeight,
                    duration: 200, //window.innerHeight - isOnlyH5 ? textTarget?.offsetHeight / 2 : textTarget?.offsetHeight,
                    onEnter: () => setTextEnter(true),
                    //onLeave: () => setTextEnter(false),
                });
                // sceneTextLeaveK = AniContainer.create({
                //     triggerElement: '.dpu-detail-K .text-info',
                //     triggerHook: 1,
                //     offset: 0,
                //     duration: window.innerHeight * 3.5,
                //     onLeave: () => setTextEnter(false),
                // });
            };
            resizeAni();
            //window.addEventListener('resize', resizeAni);
            return () => {
                if (sceneTextEnterK) {
                    AniContainer.removeScene(sceneTextEnterK);
                    sceneTextEnterK = null;
                }
                if (sceneTextLeaveK) {
                    AniContainer.removeScene(sceneTextLeaveK);
                    sceneTextLeaveK = null;
                }

                // window.removeEventListener('resize', resizeAni);
            };
        }
    }, []);

    return (
        <section className={`dpu-detail-K dpu-detail-section ${css['dpu-detail-K']}`}>
            <div className={`text-info ${textEnter ? 'enter' : ''}`}>
                <p className="subtitle">{t('secK_subtitle')}</p>
                <h2 className="title">
                    {t.rich('secK_title', {
                        b: (text: string) => <p className="blue">{text}</p>,
                    })}
                </h2>
            </div>
            <ul className="cards">
                {cards?.map((card: any, k: number) => (
                    <li className="card" key={k}>
                        <p className="card-title">{t(card?.title)}</p>
                        <p className="card-desc">
                            {t.rich(card?.desc, {
                                w: (text: string) => <span className="white">{text}</span>,
                            })}
                        </p>
                        {card?.url && (
                            <Link className="card-link" href={card?.url} target="_blank">
                                <span className="link-text">
                                    {t('secN_link')}
                                    <svg className="link-icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M6.25651 2.35901L11.5898 7.69234L6.25651 13.0257"
                                            stroke="#3F68E0"
                                            strokeWidth="1.4"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                </span>
                            </Link>
                        )}
                        <div className="card-img">
                            <EFPicture src={`${card?.img}.jpg`} srcPad={`${card?.img}_768.jpg`} srcMobile={`${card?.img}_768.jpg`} alt={t(card?.title)} />
                        </div>
                    </li>
                ))}
            </ul>
        </section>
    );
}
